/**
 * Iter-127 — Web Vitals beacon wiring.
 *
 * Subscribes to LCP, INP, CLS, FCP, TTFB on every page-load and posts
 * each one to `/api/perf/vitals` via `sendBeacon` (falls back to
 * `fetch keepalive` when the beacon API is unavailable). The backend
 * stores raw events; `/api/admin/vitals/summary` aggregates p75 per
 * route for the admin panel.
 *
 * Safe in dev: silently no-ops if `REACT_APP_BACKEND_URL` is missing.
 */
import { onCLS, onINP, onLCP, onFCP, onTTFB } from "web-vitals";
import { isSeoCheckFrame } from "./seoCheckFrame";

const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL || ""}/api/perf/vitals`;

function send(metric) {
  if (!process.env.REACT_APP_BACKEND_URL || isSeoCheckFrame()) return;
  const body = JSON.stringify({
    name: metric.name,
    value: Math.round(metric.value * 1000) / 1000,
    path: window.location.pathname || "/",
    rating: metric.rating,
    id: metric.id,
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        ENDPOINT,
        new Blob([body], { type: "application/json" }),
      );
    } else {
      fetch(ENDPOINT, {
        method: "POST",
        body,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* swallow — perf telemetry must never break the page */
  }
}

export function initWebVitals() {
  if (typeof window === "undefined") return;
  // Idempotent — guard against accidental double-init when React
  // strict-mode re-mounts during dev.
  if (window.__cs_vitals_inited) return;
  window.__cs_vitals_inited = true;
  onCLS(send);
  onINP(send);
  onLCP(send);
  onFCP(send);
  onTTFB(send);
}
